import { render, staticRenderFns } from "./StaffSingleInfo.vue?vue&type=template&id=577646c6&"
import script from "./StaffSingleInfo.vue?vue&type=script&lang=js&"
export * from "./StaffSingleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports